import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export function openConfirmModal(message: string | string[], title = 'Please Confirm'): Promise<boolean> {
    const container = document.createElement('div');
    document.body.appendChild(container);

    return new Promise<boolean>((resolve) => {
        const ConfirmDialog = () => {
            const [open, setOpen] = useState(true);

            const handleClose = (result: boolean) => {
                setOpen(false);
                resolve(result);
                setTimeout(() => {
                    container.remove();
                }, 150); // allow dialog close animation
            };

            const content = Array.isArray(message) ? (
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                    {message.map((m, i) => (
                        <li key={i}>{m}</li>
                    ))}
                </ul>
            ) : (
                <DialogContentText>{message}</DialogContentText>
            );

            return createPortal(
                <Dialog
                    open={open}
                    onClose={() => handleClose(false)}
                    aria-labelledby="confirm-dialog-title"
                >
                    {title && <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>}
                    <DialogContent>{content}</DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => handleClose(false)}>Cancel</Button>
                        <Button variant="contained" onClick={() => handleClose(true)} autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>,
                container
            );
        };

        // Just render it once
        const root = React.createElement(ConfirmDialog);
        import('react-dom').then((ReactDOM) => {
            ReactDOM.render(root, container);
        });
    });
}
